import Vue from 'vue'

export default function moveStudentToGroup({ studentId, groupId, data }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/students/" + studentId + "/group/" + groupId + "/move"
    return Vue.http
        .put(url, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json()).catch(() => { throw "Ошибка сохранения" })
}